<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!--------------------------提案---------------------------------->
    <div *ngIf="1 == detailTask?.agenda_kbn.id">
      <!-- タイトル -->
      <div class="title">
        <h1>{{ proposaDetail?.organization_name }}からのご提案</h1>
      </div>
    </div>

    <!--------------------------依頼---------------------------------->
    <div *ngIf="2 == detailTask?.agenda_kbn.id">
      <!-- タイトル -->
      <div class="title">
        <h1>{{ proposaDetail?.organization_name }}からのご依頼</h1>
      </div>
    </div>

    <!-- 内閣府承認情報 -->
    <div
      class="approval-information"
      *ngIf="
        decisionPerspective(this.proposaDetail?.member_id) ||
        decisionSecretariat()
      "
    >
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == proposaDetail?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ proposaDetail?.status.name }}
                    </label>
                    <!-- 承認日付 -->
                    <label>
                      {{ proposaDetail?.status_datetime }}
                    </label>
                  </label>

                  <div>
                    <!-- 前後確認 -->
                    <button
                      pButton
                      type="button"
                      label="前後確認"
                      class="button3 approval-button"
                      (click)="openDiffDialog('c601')"
                      *ngIf="decisionSecretariat()"
                    ></button>
                    <!-- 承認可否 -->
                    <button
                      pButton
                      type="button"
                      label="ステータス登録"
                      class="button3 approval-button"
                      (click)="openSmallApprovalDialog()"
                      *ngIf="decisionSecretariat()"
                    ></button>
                  </div>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ proposaDetail?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 現在の検討状況 -->
    <div class="stats-button-area">
      <button
        pButton
        type="button"
        class="stats-button-size button1"
        (click)="jumpChatTop()"
      >
        <div>
          現在の検討状況：
          <label>
            {{ proposaDetail?.status_agenda.name }}
          </label>
        </div>
        検討状況・コメント登録へ<i class="pi pi-angle-down"></i>
      </button>
    </div>

    <!--------------------------提案---------------------------------->
    <div *ngIf="1 == detailTask?.agenda_kbn.id">
      <!-- ご提案の内容 -->
      <div class="proposing-detail">
        <!-- タイトル -->
        <div class="proposing-detail-title">
          <h1>ご提案の内容</h1>
        </div>
        <!-- 編集ボタンエリア -->
        <div class="p-d-flex p-jc-end">
          <!-- 編集ボタン -->
          <button
            pButton
            type="button"
            label="編集する"
            icon="pi pi-pencil"
            class="button1"
            (click)="moveC401()"
            *ngIf="
              proposaDetail?.status.id != 3 &&
              (decisionPerspective(this.proposaDetail?.member_id) ||
                decisionSecretariat()) &&
              0 == detailTask?.delete_datetime.length
            "
          ></button>
        </div>
        <!-- 提案情報 -->
        <div class="proposing-detail-information">
          <!-- 提案内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 提案タイトル -->
              <tr>
                <td class="item-name">提案タイトル</td>
                <td class="item-information">
                  {{ proposaDetail?.title }}
                </td>
              </tr>
              <!-- 提案内容詳細 -->
              <tr>
                <td class="item-name">提案内容詳細</td>
                <td class="item-information">
                  {{ proposaDetail?.detail }}
                </td>
              </tr>
              <!-- 類似する貴団体の官民連携事例 -->
              <tr *ngIf="proposaDetail?.case.length != 0">
                <td class="item-name">類似する貴団体の官民連携事例</td>
                <td class="item-information">
                  {{ proposaDetail?.case }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <!-- 課題 -->
      <div class="task">
        <p-button
          [label]="
            proposaDetail?.agenda_id +
            '　' +
            proposaDetail?.agenda_organization_name +
            '　' +
            proposaDetail?.agenda_solution_title
          "
          icon="pi pi-angle-right"
          iconPos="right"
          styleClass="p-button-link task-button"
          (click)="moveC301()"
        >
        </p-button>
      </div>
      <!-- 課題記載しか会員ID or 提案者専用 -->
      <div
        *ngIf="
          decisionPerspective(proposaDetail?.member_id) ||
          decisionPerspective(proposaDetail?.member_id_agenda) ||
          decisionSecretariat()
        "
      >
        <!-- 非公開掲示板のページアンカー -->
        <a id="jump-chat-top"></a>

        <!-- 非公開掲示板 -->
        <div class="chat-detail">
          <!-- タイトル -->
          <div class="chat-detail-title">
            <h1>非公開掲示板</h1>
          </div>

          <!-- 個別チャット情報 -->
          <div class="chat-detail-information">
            <!-- チャットコンテンツ -->
            <div class="chat-content">
              <p-scrollPanel styleClass="chat-scrol">
                <!-- チャットブロック(未回答) -->
                <div
                  class="unanswered-chat-block"
                  *ngIf="0 == proposaDetail?.status_agenda.id"
                >
                  <div class="chat-comment">
                    <label
                      *ngIf="
                        decisionPerspective(proposaDetail?.member_id_agenda) ||
                        decisionSecretariat()
                      "
                    >
                      提案元へ回答をしておりません。
                    </label>
                    <label
                      *ngIf="
                        !decisionPerspective(proposaDetail?.member_id_agenda) &&
                        !decisionSecretariat()
                      "
                    >
                      提案先からの回答はまだありません。
                    </label>
                  </div>
                </div>

                <!-- チャットブロック -->
                <div
                  class="chat-block"
                  *ngFor="let chatComment of chatCommentList"
                >
                  <!-- チャットブロック(自身) -->
                  <div
                    class="private-chat-block"
                    *ngIf="
                      !decisionSecretariat() &&
                      decisionPerspective(chatComment.member_id_comment) &&
                      1 == chatComment.status
                    "
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      {{ chatComment.chat_comment }}
                    </div>
                  </div>
                  <!-- チャットブロック(相手) -->
                  <div
                    class="public-chat-block"
                    *ngIf="
                      (decisionSecretariat() ||
                        !decisionPerspective(chatComment.member_id_comment)) &&
                      1 == chatComment.status
                    "
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      {{ chatComment.chat_comment }}
                    </div>
                  </div>

                  <!-- チャットブロック(不適切) -->
                  <div
                    class="unsuitable-chat-block"
                    *ngIf="0 == chatComment.status"
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      不適切な文言が含まれる為、削除致しました。
                    </div>
                  </div>
                </div>
              </p-scrollPanel>
            </div>

            <!-- チャット入力フォーム -->
            <div
              class="chat-input-information"
              [formGroup]="c601ChatInputForm"
              *ngIf="
                decisionPerspective(proposaDetail?.member_id_agenda) ||
                decisionSecretariat()
              "
            >
              <!-- 意見交換希望のページアンカー -->
              <a id="jump-exchange-of-opinions"></a>

              <!-- このご提案に対して返信してください。 -->
              <div class="reply-proposal">
                <div class="chat-sub-content">
                  <div class="selection-consideration">
                    <label class="chat-sub-content-title">
                      検討状況を選択し、詳細の状況や質問事項等をコメント欄に記載してください<span
                        class="required"
                        >【必須】</span
                      >
                    </label>
                    <div class="dropdown-area">
                      <p-dropdown
                        [options]="getDicList(2015)"
                        optionLabel="sp_name"
                        optionValue="sp_code"
                        placeholder="選択してください"
                        [showClear]="true"
                        (onChange)="setChatComment($event.value)"
                        styleClass="status_agenda-dropdown"
                        formControlName="status_agenda"
                      ></p-dropdown>
                    </div>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message
                      [control]="c601ChatInputForm.get('status_agenda')"
                    >
                    </app-validator-message>
                  </div>

                  <div class="chat_comment">
                    コメント欄:&emsp;コメント欄は、適宜、編集してください。登録した内容は非公開掲示板に反映されます。
                    <textarea
                      pInputTextarea
                      formControlName="chat_comment"
                    ></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message
                      [control]="c601ChatInputForm.get('chat_comment')"
                    >
                    </app-validator-message>
                  </div>
                  <div class="p-d-flex p-jc-center button-area">
                    <button
                      pButton
                      type="button"
                      label="登録する"
                      class="button-default-size button"
                      (click)="onChatInsert()"
                      [disabled]="!c601ChatInputForm.valid"
                    ></button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 個別チャットへ投稿 -->
            <div
              class="chat-input-information"
              [formGroup]="c601ChatInputForm"
              *ngIf="
                (1 == proposaDetail?.status_agenda.id ||
                  5 == proposaDetail?.status_agenda.id) &&
                decisionPerspective(proposaDetail?.member_id) &&
                !decisionSecretariat()
              "
            >
              <div class="chat-only">
                <div class="chat-sub-content">
                  コメント欄:
                  <textarea
                    pInputTextarea
                    formControlName="chat_comment"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c601ChatInputForm.get('chat_comment')"
                  >
                  </app-validator-message>
                </div>
                <div class="p-d-flex p-jc-center button-area">
                  <button
                    pButton
                    type="button"
                    label="登録する"
                    class="button-default-size button"
                    (click)="onChatInsert()"
                    [disabled]="!c601ChatInputForm.valid"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 意見交換後の連携状況調査にご協力ください -->
        <div
          [formGroup]="c601CooperationInputForm"
          class="research"
          *ngIf="
            (decisionPerspective(proposaDetail?.member_id_agenda) ||
              decisionSecretariat()) &&
            5 == proposaDetail?.status_agenda.id
          "
        >
          <!-- タイトル -->
          <div class="research-title">
            <h1>意見交換後の連携状況調査にご協力ください。</h1>
          </div>
          <!-- 備考 -->
          <div class="note">
            ※本調査結果は他の会員へは一切公開されません。今後のプラットフォーム運営の参考とさせていただきます。<br />
            ※連携状況に未回答の場合、または継続協議中、未定と回答した場合、一定期間後に再度状況調査の依頼をする場合があります。
          </div>

          <!-- コンテンツ -->
          <div class="research-content">
            <!-- 意見交換実施後の連携状況 -->
            <div class="sub-content">
              <label class="sub-content-title">
                1.意見交換実施後の連携状況
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2009); let i = index"
                >
                  <p-radioButton
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    formControlName="questionary1"
                  ></p-radioButton>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary1')"
                >
                </app-validator-message>
              </div>
            </div>
            <!-- 設問1で（D）連携に至らず（終了）と回答した場合、その理由を教えて下さい（複数回答可） -->
            <div class="sub-content">
              <label class="sub-content-title">
                2.設問1で（D）連携に至らず（終了）と回答した場合、その理由を教えて下さい（複数回答可）
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2010); let i = index"
                >
                  <p-checkbox
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    [formControl]="
                      c601CooperationInputForm.controls['questionary2']
                    "
                  ></p-checkbox>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary2')"
                >
                </app-validator-message>
              </div>
            </div>

            <!-- 提案に対する評価 -->
            <div class="sub-content">
              <label class="sub-content-title"> 3.提案に対する評価 </label>
              <div class="selection-content">
                3-1 貴団体において、実現可能性がある提案でしたか？
                <div class="p-d-flex margin-vertical">
                  <span
                    class="margin-side"
                    *ngFor="let dicData of getDicList(2011)"
                  >
                    <p-radioButton
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      formControlName="questionary3"
                    >
                    </p-radioButton>
                  </span>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary3')"
                >
                </app-validator-message>
              </div>
              <div class="selection-margin-vertical"></div>
              <div class="selection-content">
                3-2 提案内容に対して、提案者の熟練度は高いと感じましたか？
                <div class="p-d-flex margin-vertical">
                  <span
                    class="margin-side"
                    *ngFor="let dicData of getDicList(2012)"
                  >
                    <p-radioButton
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      formControlName="questionary4"
                    >
                    </p-radioButton>
                  </span>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary4')"
                >
                </app-validator-message>
              </div>
              <div class="selection-margin-vertical"></div>
              <div class="selection-content">
                3-3
                貴団体が想定していた提案と比べて、新規性や意外性がありましたか？
                <div class="p-d-flex margin-vertical">
                  <span
                    class="margin-side"
                    *ngFor="let dicData of getDicList(2011)"
                  >
                    <p-radioButton
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      formControlName="questionary5"
                    >
                    </p-radioButton>
                  </span>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary5')"
                >
                </app-validator-message>
              </div>
              <div class="selection-margin-vertical"></div>
              <div class="selection-content">
                3-4 貴団体の課題解決に、本提案が寄与すると感じましたか？
                <div class="p-d-flex margin-vertical">
                  <span
                    class="margin-side"
                    *ngFor="let dicData of getDicList(2013)"
                  >
                    <p-radioButton
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      formControlName="questionary6"
                    >
                    </p-radioButton>
                  </span>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary6')"
                >
                </app-validator-message>
              </div>
            </div>

            <!-- 自由記載欄 -->
            <div class="sub-content">
              <label class="sub-content-title">
                4.自由記載欄（400字まで）
              </label>
              <div class="selection-content">
                <textarea pInputTextarea formControlName="opinion"></textarea>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('opinion')"
                >
                </app-validator-message>
              </div>
            </div>

            <div class="p-d-flex p-jc-center button-area">
              <button
                pButton
                type="button"
                label="登録する"
                class="button-default-size button"
                (click)="insertIndustrializationReport(1)"
                [disabled]="!c601CooperationInputForm.valid"
              ></button>
            </div>
          </div>
        </div>

        <!-- アンケートにご協力ください -->
        <div
          [formGroup]="c601AnswerInputForm"
          class="research"
          *ngIf="
            (decisionPerspective(proposaDetail?.member_id_agenda) ||
              decisionSecretariat()) &&
            (2 == proposaDetail?.status_agenda.id ||
              3 == proposaDetail?.status_agenda.id ||
              4 == proposaDetail?.status_agenda.id)
          "
        >
          <!-- タイトル -->
          <div class="research-title">
            <h1>アンケートにご協力ください。</h1>
          </div>
          <!-- 備考 -->
          <div class="note">
            ※本調査結果は他の会員へは一切公開されません。今後のプラットフォーム運営の参考とさせていただきます。<br />
            ※連携状況に未回答の場合、または継続協議中、未定と回答した場合、一定期間後に再度状況調査の依頼をする場合があります。
          </div>

          <!-- コンテンツ -->
          <div class="research-content">
            <!-- 本提案を見送った理由を教えて下さい（複数回答可） -->
            <div class="sub-content">
              <label class="sub-content-title">
                1.本提案を見送った理由を教えて下さい（複数回答可）
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2014); let i = index"
                >
                  <p-checkbox
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    [formControl]="c601AnswerInputForm.controls['questionary1']"
                  >
                  </p-checkbox>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601AnswerInputForm.get('questionary1')"
                >
                </app-validator-message>
              </div>
            </div>

            <!-- 自由記載欄 -->
            <div class="sub-content">
              <label class="sub-content-title">
                2. 自由記載欄（400字まで）
              </label>
              <div class="selection-content">
                <textarea pInputTextarea formControlName="opinion"></textarea>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601AnswerInputForm.get('opinion')"
                >
                </app-validator-message>
              </div>
            </div>

            <div class="p-d-flex p-jc-center button-area">
              <button
                pButton
                type="button"
                label="登録する"
                class="button-default-size button"
                (click)="insertIndustrializationReport(2)"
                [disabled]="!c601AnswerInputForm.valid"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--------------------------依頼---------------------------------->
    <div *ngIf="2 == detailTask?.agenda_kbn.id">
      <!-- ご依頼の内容 -->
      <div class="proposing-detail">
        <!-- タイトル -->
        <div class="proposing-detail-title">
          <h1>ご依頼の内容</h1>
        </div>
        <!-- 編集ボタンエリア -->
        <div class="p-d-flex p-jc-end">
          <!-- 編集ボタン -->
          <button
            pButton
            type="button"
            label="編集する"
            icon="pi pi-pencil"
            class="button1"
            (click)="moveC401()"
            *ngIf="
              proposaDetail?.status.id != 3 &&
              (decisionPerspective(this.proposaDetail?.member_id) ||
                decisionSecretariat()) &&
              0 == detailTask?.delete_datetime.length
            "
          ></button>
        </div>
        <!-- 提案情報 -->
        <div class="proposing-detail-information">
          <!-- 提案内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 提案タイトル -->
              <tr>
                <td class="item-name">依頼タイトル</td>
                <td class="item-information">
                  {{ proposaDetail?.title }}
                </td>
              </tr>
              <!-- 提案内容詳細 -->
              <tr>
                <td class="item-name">依頼内容</td>
                <td class="item-information">
                  {{ proposaDetail?.detail }}
                </td>
              </tr>
              <!-- 質問事項 -->
              <tr *ngIf="proposaDetail?.question.length != 0">
                <td class="item-name">質問事項</td>
                <td class="item-information">
                  {{ proposaDetail?.question }}
                </td>
              </tr>
              <!-- 参考情報 -->
              <tr *ngIf="proposaDetail?.reference.length != 0">
                <td class="item-name">参考情報</td>
                <td class="item-information">
                  {{ proposaDetail?.reference }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <!-- ソリューション -->
      <div class="solution">
        <p-button
          [label]="
            proposaDetail?.agenda_id +
            '　' +
            proposaDetail?.agenda_organization_name +
            '　' +
            proposaDetail?.agenda_solution_title
          "
          icon="pi pi-angle-right"
          iconPos="right"
          styleClass="p-button-link solution-button"
          (click)="moveC301()"
        >
        </p-button>
      </div>

      <!-- 課題記載しか会員ID or 提案者専用 -->
      <div
        *ngIf="
          decisionPerspective(proposaDetail?.member_id) ||
          decisionPerspective(proposaDetail?.member_id_agenda) ||
          decisionSecretariat()
        "
      >
        <!-- 非公開掲示板のページアンカー -->
        <a id="jump-chat-top"></a>

        <!-- 非公開掲示板 -->
        <div class="chat-detail">
          <!-- タイトル -->
          <div class="chat-detail-title">
            <h1>非公開掲示板</h1>
          </div>

          <!-- 個別チャット情報 -->
          <div class="chat-detail-information">
            <!-- チャットコンテンツ -->
            <div class="chat-content">
              <p-scrollPanel styleClass="chat-scrol">
                <!-- チャットブロック(未回答) -->
                <div
                  class="unanswered-chat-block"
                  *ngIf="0 == proposaDetail?.status_agenda.id"
                >
                  <div class="chat-comment">
                    <label
                      *ngIf="
                        decisionPerspective(proposaDetail?.member_id_agenda) ||
                        decisionSecretariat()
                      "
                    >
                      依頼元へ回答をしておりません。
                    </label>
                    <label
                      *ngIf="
                        !decisionPerspective(proposaDetail?.member_id_agenda) &&
                        !decisionSecretariat()
                      "
                    >
                      依頼先からの回答はまだありません。
                    </label>
                  </div>
                </div>

                <!-- チャットブロック -->
                <div
                  class="chat-block"
                  *ngFor="let chatComment of chatCommentList"
                >
                  <!-- チャットブロック(自身) -->
                  <div
                    class="private-chat-block"
                    *ngIf="
                      !decisionSecretariat() &&
                      decisionPerspective(chatComment.member_id_comment) &&
                      1 == chatComment.status
                    "
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      {{ chatComment.chat_comment }}
                    </div>
                  </div>
                  <!-- チャットブロック(相手) -->
                  <div
                    class="public-chat-block"
                    *ngIf="
                      (decisionSecretariat() ||
                        !decisionPerspective(chatComment.member_id_comment)) &&
                      1 == chatComment.status
                    "
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      {{ chatComment.chat_comment }}
                    </div>
                  </div>

                  <!-- チャットブロック(不適切) -->
                  <div
                    class="unsuitable-chat-block"
                    *ngIf="0 == chatComment.status"
                  >
                    <div>
                      <p class="name">{{ chatComment.organization_name }}</p>
                      <p class="datetime">{{ chatComment.create_datetime }}</p>
                    </div>
                    <div class="chat-comment">
                      不適切な文言が含まれる為、削除致しました。
                    </div>
                  </div>
                </div>
              </p-scrollPanel>
            </div>

            <!-- チャット入力フォーム -->
            <div
              class="chat-input-information"
              [formGroup]="c601ChatInputForm"
              *ngIf="
                decisionPerspective(proposaDetail?.member_id_agenda) ||
                decisionSecretariat()
              "
            >
              <!-- 意見交換希望のページアンカー -->
              <a id="jump-exchange-of-opinions"></a>

              <!-- このご提案に対して返信してください。 -->
              <div class="reply-proposal">
                <div class="chat-sub-content">
                  <div class="selection-consideration">
                    <label class="chat-sub-content-title">
                      検討状況を選択し、詳細の状況や質問事項等をコメント欄に記載してください<span
                        class="required"
                        >【必須】</span
                      >
                    </label>
                    <div class="dropdown-area">
                      <p-dropdown
                        [options]="getDicList(2022)"
                        optionLabel="sp_name"
                        optionValue="sp_code"
                        placeholder="選択してください"
                        [showClear]="true"
                        (onChange)="setChatCommentRequest($event.value)"
                        styleClass="status_agenda-dropdown"
                        formControlName="status_agenda"
                      ></p-dropdown>
                    </div>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message
                      [control]="c601ChatInputForm.get('status_agenda')"
                    >
                    </app-validator-message>
                  </div>

                  <div class="chat_comment">
                    コメント欄:&emsp;コメント欄は、適宜、編集してください。登録した内容は非公開掲示板に反映されます。
                    <textarea
                      pInputTextarea
                      formControlName="chat_comment"
                    ></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message
                      [control]="c601ChatInputForm.get('chat_comment')"
                    >
                    </app-validator-message>
                  </div>
                  <div class="p-d-flex p-jc-center button-area">
                    <button
                      pButton
                      type="button"
                      label="登録する"
                      class="button-default-size button"
                      (click)="onChatInsert()"
                      [disabled]="!c601ChatInputForm.valid"
                    ></button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 個別チャットへ投稿 -->
            <div
              class="chat-input-information"
              [formGroup]="c601ChatInputForm"
              *ngIf="
                (1 == proposaDetail?.status_agenda.id ||
                  5 == proposaDetail?.status_agenda.id) &&
                !decisionSecretariat() &&
                decisionPerspective(proposaDetail?.member_id)
              "
            >
              <div class="chat-only">
                <div class="chat-sub-content">
                  コメント欄:
                  <textarea
                    pInputTextarea
                    formControlName="chat_comment"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="c601ChatInputForm.get('chat_comment')"
                  >
                  </app-validator-message>
                </div>
                <div class="p-d-flex p-jc-center button-area">
                  <button
                    pButton
                    type="button"
                    label="登録する"
                    class="button-default-size button"
                    (click)="onChatInsert()"
                    [disabled]="!c601ChatInputForm.valid"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- アンケートにご協力ください -->
        <div
          [formGroup]="c601AnswerInputForm"
          class="research"
          *ngIf="
            (decisionPerspective(proposaDetail?.member_id_agenda) ||
              decisionSecretariat()) &&
            (2 == proposaDetail?.status_agenda.id ||
              3 == proposaDetail?.status_agenda.id)
          "
        >
          <!-- タイトル -->
          <div class="research-title">
            <h1>アンケートにご協力ください。</h1>
          </div>
          <!-- 備考 -->
          <div class="note">
            ※本調査結果は他の会員へは一切公開されません。今後のプラットフォーム運営の参考とさせていただきます。<br />
            ※連携状況に未回答の場合、または継続協議中、未定と回答した場合、一定期間後に再度状況調査の依頼をする場合があります。
          </div>

          <!-- コンテンツ -->
          <div class="research-content">
            <!-- 依頼に対して、辞退した理由を教えてください（複数回答可） -->
            <div class="sub-content">
              <label class="sub-content-title">
                1.依頼に対して、辞退した理由を教えてください（複数回答可）
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2023); let i = index"
                >
                  <p-checkbox
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    [formControl]="c601AnswerInputForm.controls['questionary1']"
                  >
                  </p-checkbox>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601AnswerInputForm.get('questionary1')"
                >
                </app-validator-message>
              </div>
            </div>

            <!-- 自由記載欄 -->
            <div class="sub-content">
              <label class="sub-content-title">
                2.自由記載欄（400字まで）
              </label>
              <div class="selection-content">
                <textarea pInputTextarea formControlName="opinion"></textarea>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601AnswerInputForm.get('opinion')"
                >
                </app-validator-message>
              </div>
            </div>

            <div class="p-d-flex p-jc-center button-area">
              <button
                pButton
                type="button"
                label="登録する"
                class="button-default-size button"
                (click)="insertIndustrializationReport(2)"
                [disabled]="!c601AnswerInputForm.valid"
              ></button>
            </div>
          </div>
        </div>

        <!-- 意見交換後の連携状況調査にご協力ください -->
        <div
          [formGroup]="c601CooperationInputForm"
          class="research"
          *ngIf="
            (decisionPerspective(proposaDetail?.member_id_agenda) ||
              decisionSecretariat()) &&
            5 == proposaDetail?.status_agenda.id
          "
        >
          <!-- タイトル -->
          <div class="research-title">
            <h1>意見交換後の連携状況調査にご協力ください。</h1>
          </div>
          <!-- 備考 -->
          <div class="note">
            ※本調査結果は他の会員へは一切公開されません。今後のプラットフォーム運営の参考とさせていただきます。<br />
            ※連携状況に未回答の場合、または継続協議中、未定と回答した場合、一定期間後に再度状況調査の依頼をする場合があります。
          </div>

          <!-- コンテンツ -->
          <div class="research-content">
            <!-- 意見交換実施後の連携状況 -->
            <div class="sub-content">
              <label class="sub-content-title">
                1.意見交換実施後の連携状況
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2009); let i = index"
                >
                  <p-radioButton
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    formControlName="questionary1"
                  ></p-radioButton>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary1')"
                >
                </app-validator-message>
              </div>
            </div>
            <!-- 設問1で（D）連携に至らず（終了）と回答した場合、その理由を教えて下さい（複数回答可） -->
            <div class="sub-content">
              <label class="sub-content-title">
                2.設問1で（D）連携に至らず（終了）と回答した場合、その理由を教えて下さい（複数回答可）
              </label>
              <div class="selection-content">
                <div
                  class="margin-vertical"
                  *ngFor="let dicData of getDicList(2024); let i = index"
                >
                  <p-checkbox
                    [label]="
                      '(' + numberChangeEnglish(i) + ') ' + dicData.sp_name
                    "
                    [value]="dicData.sp_code"
                    [formControl]="
                      c601CooperationInputForm.controls['questionary2']
                    "
                  ></p-checkbox>
                </div>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('questionary2')"
                >
                </app-validator-message>
              </div>
            </div>

            <!-- 3.自由記載欄（400字まで） -->
            <div class="sub-content">
              <label class="sub-content-title">
                3.自由記載欄（400字まで）
              </label>
              <div class="selection-content">
                <textarea pInputTextarea formControlName="opinion"></textarea>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message
                  [control]="c601CooperationInputForm.get('opinion')"
                >
                </app-validator-message>
              </div>
            </div>

            <div class="p-d-flex p-jc-center button-area">
              <button
                pButton
                type="button"
                label="登録する"
                class="button-default-size button"
                (click)="insertIndustrializationReport(1)"
                [disabled]="!c601CooperationInputForm.valid"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getProposaDetail(true)"
></app-approval-dialog>

<!-- 共通部品_差分比較ダイアログ -->
<app-diff-table></app-diff-table>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>